module.exports = __webpack_public_path__ + "98cf20c72a0d44b699c0949a8854f982.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/crosshair.png
 ** module id = 1048
 ** module chunks = 0
 **/